import { pinia } from '@tools/pinia';
import { createApp } from 'vue';
import NavbarDesktop from '@layout/nav-v2/desktop/NavbarDesktop.vue';
import TopNavbarDesktop from '@layout/nav-v2/desktop/TopNavbarDesktop.vue';
import VueClickAway from 'vue3-click-away';

export function initNavbarDesktop(): void {
  if (!document.getElementById('top-navbar-desktop')) {
    return;
  }

  createApp(TopNavbarDesktop)
    .use(pinia)
    .use(VueClickAway)
    .mount('#top-navbar-desktop');

  if (!document.getElementById('navbar-desktop')) {
    return;
  }

  createApp(NavbarDesktop)
    .use(pinia)
    .mount('#navbar-desktop');
}
